import { getCurrentPlan } from "../../services/api";
import * as types from "../types";

const subscriptionRequest = () => ({
  type: types.SUBSCRIPTION_REQUEST,
});

const subscriptionSuccess = (data) => ({
  type: types.SUBSCRIPTION_SUCCESS,
  payload: data,
});

const subscriptionFailure = (error) => ({
  type: types.SUBSCRIPTION_FAILURE,
  payload: error,
});

export const getActiveSubscription = () => {
  return async (dispatch) => {
    dispatch(subscriptionRequest());
    try {
      const response = await getCurrentPlan();
      if (response.data.success) {
        dispatch(subscriptionSuccess(response.data.data));
      }
    } catch (error) {
      dispatch(subscriptionFailure(error.message));
    }
  };
};